import request from './request';

export function login(payload) {
  return request.post('/auth/agent/login', payload);
}

